import { render, staticRenderFns } from "./InfoTabView.vue?vue&type=template&id=7c3f8786&scoped=true&"
import script from "./InfoTabView.vue?vue&type=script&lang=js&"
export * from "./InfoTabView.vue?vue&type=script&lang=js&"
import style0 from "./InfoTabView.vue?vue&type=style&index=0&id=7c3f8786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f8786",
  null
  
)

export default component.exports